import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

function format(seconds: number): string {
  const total = Math.abs(Math.round(seconds));
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  if (days > 0) return `${days} j ${hours} h`;
  if (hours > 0) return `${hours} h ${String(minutes).padStart(2, "0")} min`;
  return `${minutes} min ${String(secs).padStart(2, "0")} s`;
}

/**
 * Compte à rebours jusqu'à l'échéance d'une demande (normal 1 h, urgent 20 min, ou délai donné par le médecin) ;
 * passe en orange sous 10 minutes et en rouge une fois l'échéance dépassée.
 */
export function DueCountdown({ dueAt }: { dueAt: string | null | undefined }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!dueAt) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [dueAt]);

  if (!dueAt) return <span className="text-xs text-muted">—</span>;

  const left = (new Date(dueAt).getTime() - now) / 1000;
  const tone = left < 0 ? "text-red-700" : left < 600 ? "text-amber-700" : "text-foreground";

  return (
    <span className={`inline-flex items-center gap-1 text-sm font-semibold tabular-nums ${tone}`} title={new Date(dueAt).toLocaleString("fr-FR")}>
      <Timer size={13} aria-hidden="true" />
      {left < 0 ? `Dépassé de ${format(left)}` : format(left)}
    </span>
  );
}
